import {
  ActiveStateActionsFragment,
  LapsedStateFinalisationFragment,
} from '../../../../../graphql/api';
import { formatBalance } from '../../../../../helpers/formatHelpers';
import { InfoItem } from '../types';
import { FinalisationFinalPaymentState } from '@graphql/types';

export const mapActiveStateActions = (
  actions: ActiveStateActionsFragment[],
): InfoItem[] => {
  return actions.length > 0
    ? actions.map(action => {
        switch (action.__typename) {
          case 'PaymentAction':
            return {
              title: 'Payment required',
              value: formatBalance(action.payload.amount),
            };
          case 'NewQuoteAvailableAction': {
            return { title: action.title };
          }
          case 'NegativeBalanceAction':
            return { title: 'Negative balance settlement' };
          case 'OdometerDueAction':
          case 'OdometerActionV2': {
            return { title: 'Odometer photo required' };
          }
          default:
            return { title: '' };
        }
      })
    : [noPendingActions()];
};

export const mapLapsedStateAction = (
  finalisation: LapsedStateFinalisationFragment,
): InfoItem => {
  switch (finalisation.__typename) {
    case 'FinalisationAccountFinalised': {
      return {
        title: `Account finalized`,
      };
    }

    case 'FinalisationTallyUpRequired':
      return {
        title: `Tally up required`,
      };

    case 'FinalisationTallyUpProcessing':
      return {
        title: 'Tally up pending',
      };

    case 'FinalisationFinalBill': {
      let message = '';
      switch (finalisation.state) {
        case FinalisationFinalPaymentState.PaymentRequired:
          message = 'User to settle';
          break;
        case FinalisationFinalPaymentState.RefundRequired:
          message = 'Waiting for refund';
          break;
        case FinalisationFinalPaymentState.AwaitingFinalBillCreation:
          message = 'Creating final bill';
          break;
        case FinalisationFinalPaymentState.AwaitingFinalBillProcessing:
          message = 'Bill processing';
          break;
        case FinalisationFinalPaymentState.FinalBalanceCalculationPending:
          message = 'Apply 50 mile charge';
          break;
      }

      return {
        title: `Final bill - ${message}`,
      };
    }

    case 'FinalisationFinalBalance': {
      let message = '';
      switch (finalisation.state) {
        case FinalisationFinalPaymentState.PaymentRequired:
          message = 'User to settle';
          break;
        case FinalisationFinalPaymentState.RefundRequired:
          message = 'Waiting for refund';
          break;
        case FinalisationFinalPaymentState.FinalBalanceCalculationPending:
          message = 'Apply 50 mile charge';
          break;
      }

      return {
        title: message ? `Final balance - ${message}` : 'Final balance',
      };
    }
  }
};

export const noPendingActions = (): InfoItem => {
  return {
    title: 'No pending actions',
  };
};
